import { ACTION_IDS } from "../actionIds";

/**
 * Sticky header actions for customer_type === 7 (service partner).
 * Shows Kalkulačka cien when showCalculator is true, and Logout.
 */
export function getHeaderActions(context) {
  const { isLoggedIn, showCalculator } = context;
  return [
    {
      id: ACTION_IDS.CALCULATOR,
      visible: !!showCalculator,
      tooltip: "Kalkulačka cien",
      ariaLabel: "Kalkulačka cien",
      iconId: "calculator",
    },
    {
      id: ACTION_IDS.LOGOUT,
      visible: isLoggedIn,
      tooltip: "Logout",
      ariaLabel: "Logout",
      iconId: "logout",
    },
  ];
}
